import './MainHeader.scss';

import React from 'react';

import A        from 'components/A';
import Logo     from 'components/Logo';

export default class MainHeader extends React.Component {
    static propTypes = {

    };

    _openCloseMenu() {
        document.body.classList.toggle('open-menu');
    }

    render() {
        return (
            <header className="c-main-header">
                <Logo
                    orientation="horizontal"
                />

                <div className="c-main-header__nav-wrapper">
                    <A to="/users">All Users</A>
                    <A to="/data">Aggregate Data</A>
                    <A to="/algorithm">Algorithm</A>
                    <A to="/notifications">Notifications</A>
                    <A to="/prices">Class III Prices</A>
                    <A to="/ads">Ads</A>
                    <A to="/referral-codes">Referral Codes</A>
                </div>

                <A className="c-main-header__logout-link" to="/logout">
                    <img src="/img/icon--logout.svg" alt="Log out" />
                </A>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.js